module.exports = __webpack_public_path__ + "img/kip_sunglasses_head.86c22dd8.png";